// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3N7Rp","name":"Header_name__3bqA4","birthday":"Header_birthday__3Ron0","skeleton":"Header_skeleton__A52z0"};